import { GenericTradeParams } from '@ui/features/Trade/types';
import { useTranslation } from 'next-i18next';

export const useUpdateOrderTpAndSlToastOpts = ({
  genericTradeParams,
}: GenericTradeParams) => {
  const { t } = useTranslation();

  return {
    onMutateToastOpts: {},
    onSuccessToastOpts: {
      description: t('common.Stop Loss/Take Profit order update successfully'),
    },
    onErrorToastOpts: {},
  };
};
